import { allowAdditionalProperties } from "~lib/type-utils/allowAdditionalProperties";
import { DOT_SEPARATOR } from "./constants";
import uniq from "lodash/uniq";

export type VenueAddressLike = allowAdditionalProperties<{
  name: string;
  address: {
    city: string;
  };
}>;

export type VenueLike = allowAdditionalProperties<
  {
    timezone: string;
    locale: string;
  } & VenueAddressLike
>;

export function getEventVenueLocation(
  venue: VenueAddressLike | VenueAddressLike[] | undefined
) {
  if (!venue) return "";

  if (Array.isArray(venue)) {
    return uniq(venue.map(venueLocationToString)).join(` ${DOT_SEPARATOR} `);
  }

  return venueLocationToString(venue);
}

function venueLocationToString(venue: VenueAddressLike) {
  if (!venue?.name) {
    return "";
  }

  if (!venue?.address?.city) {
    return venue?.name;
  }

  return `${venue?.name}, ${venue?.address?.city}`;
}
